import React from "react";
import { Link } from "react-router-dom";
import CloseSideMenuIcon from "../../assets/images/CloseSideMenuIcon";
import NeedHelpIcon from "../../assets/images/NeedHelpIcon";
import { Constants, MenuItemsPath } from "../../constants/constants";
import Button from "./cta/Button";
import PopupModal from "./PopupModal";
import ProfileImage from "../../assets/images/profile.svg";
import { SideMenuWebProps } from "./SideMenuWeb";

const SideMenuMobile: React.FC<SideMenuWebProps> = ({
  menuItems,
  menuRef,
  componentMap,
  selectedMenuIndex,
  openModal,
  closeModal,
  closeSlider,
  handleChange,
  isModalOpen,
}) => {

  return (
    <div className="border-b-white shadow-lg">
      <div className="bg-primary text-white h-[800vh] w-[70vw] shadow-md">
        <div className="flex items-center justify-between pl-3 h-20 relative">
          <img
            className="transition-all"
            height={24}
            width={32}
            alt="ProfileImg"
            src={ProfileImage}
          />
          <div className="absolute top-1/2 right-4 z-10 transition-all cursor-pointer transform -translate-y-1/2">
            <div className="h-[24px] w-[24px]" onClick={closeSlider}>
              <CloseSideMenuIcon height="24" width="24" />
            </div>
          </div>
        </div>

        <div ref={menuRef} className="w-[60vw] h-full overflow-y-auto">
          <div className="h-[760px] rounded-b-lg">
            {menuItems.map((ele: string, index: number) => {
              const DynamicComponent = componentMap[ele];
              const color = selectedMenuIndex === index ? "#183883" : "white";
              return (
                // <Link to={MenuItemsPath[index]} key={index}>
                  <div
                    className={
                      index === 6
                        ? "mt-14 pt-14 border-t border-dashedLine border-dashed"
                        : ""
                    }
                  >
                    <div
                      onClick={() => handleChange(index)}
                      className={`flex items-center h-[35px] cursor-pointer  ${
                        selectedMenuIndex === index
                          ? "selectedSideMenu bg-sideMenubackground text-primary"
                          : "unSelectedSideMenu text-white"
                      }`}
                      style={{
                        width:"70vw", // Adjust width to prevent overflow
                      }}                    >
                      {DynamicComponent && <DynamicComponent color={color} />}
                      <div className="staffListHeader">{ele}</div>
                    </div>
                  </div>
                // {/* </Link> */}
              );
            })}

            <div className="bg-whiteColor transition-colors ml-6 text-black flex flex-col justify-center items-center rounded-lg mt-16 h-[125px] w-[204px]">
              <div className="bg-needHelp h-6 w-6 rounded-full flex justify-center items-center mt-[-45px]">
                <NeedHelpIcon />
              </div>
              <div>{Constants.help}</div>
              <div>
                <Button
                  handleClick={() => {
                    openModal();
                  }}
                  buttonText={Constants.seeTutorial}
                  className="focus:ring-4 focus:ring-gray-300 transition duration-300 bg-primary mt-4 text-white py-2 px-11 rounded-md hover:bg-whiteColor hover:text-primary"
                />
              </div>
            </div>
            <PopupModal
              buttonText="Close"
              popUpMsg="Coming Soon .."
              popUpTitle="Tutorial"
              isOpen={isModalOpen}
              onClose={closeModal}
              icon=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenuMobile;
